var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('title',[_vm._v("Chiudi")]),_vm._v(" "),_c('path',{attrs:{"d":"M16 1.8L14.2 0 8 6.2 1.8 0 0 1.8 6.2 8 0 14.2 1.8 16 8 9.8l6.2 6.2 1.8-1.8L9.8 8z","fill":"#333"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }